import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { lastOrders } from "../../libs/Atoms";


export default function RedirectToOrder({ orderId, orderHash }) {
  const [orders, setOrders] = useRecoilState(lastOrders);
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate();

  useEffect(() => {
    let redirectLast = !!searchParams.get('redirect_to_order')
    let redirectId = searchParams.get('order_number')
    let lastOrder = localStorage['lastOrder']
    if (redirectLast && lastOrder) {
      navigate('/status/' + lastOrder)
      return null
    }
    if (redirectId && orders[redirectId]) {
      navigate('/status/' + orders[redirectId])
      return null
    }
  }, [])

  return null
}